import { render, staticRenderFns } from "./NotFoundData.vue?vue&type=template&id=b2e4970c&scoped=true&"
import script from "./NotFoundData.vue?vue&type=script&lang=js&"
export * from "./NotFoundData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e4970c",
  null
  
)

export default component.exports